<template>
  <div id="print-container-wrapper">
    <div class="p-3 mx-auto" id="print-container">
      <img src="@/assets/bv-logo.svg" class="mb-2 float-right" style="width: 150px" />
      <h3>Rechnungsbegleitblatt</h3>
      <hr />
      <div class="d-print-none mb-2 mt-3">
        <b-button @click="printIt" size="sm">
          <b-icon icon="printer" class="mr-2" />
          Drucken
        </b-button>
        <b-button @click="closeIt" class="ml-3" size="sm">
          <b-icon icon="x" class="mr-2" />
          Schließen
        </b-button>
      </div>
      <div class="row mb-2">
        <div class="col">
          <label class="text-muted"><small>Projekt</small></label>
          <br />
          {{ projectIdentifier }}
        </div>
        <div class="col-3">
          <label class="text-muted"><small>Belegnummer</small></label>
          <br />
          {{ invoice.Index }}
        </div>
        <div class="col-3">
          <label class="text-muted"><small>Erfassungsdatum</small></label>
          <br />
          {{ invoice.CreatedDate }}
        </div>
      </div>
      <hr />
      <div class="row mb-2">
        <div class="col-4">
          <label class="text-muted"><small>Vergabeeinheit</small></label>
          <br />
          {{ order.Ordinal }} {{ order.DisplayName }}
        </div>
        <div
          class="col-2"
          v-show="
            SettingsStore.settings['KGR_Selections_Active'] == 'true' && SettingsStore.settings['KGR_Print'] == 'true'
          "
        >
          <label class="text-muted"><small>Kostengruppe</small></label>
          <br />
          {{ order.KGR }}
        </div>
        <div
          class="col-2"
          v-show="
            SettingsStore.settings['Responsible_Selections_Active'] == 'true' &&
              SettingsStore.settings['Responsible_Print'] == 'true'
          "
        >
          <label class="text-muted"><small>Verantwortlich</small></label>
          <br />
          {{ order.Responsible }}
        </div>
        <div
          class="col-2"
          v-show="SettingsStore.settings['FA1_Active'] == 'true' && SettingsStore.settings['FA1_Print'] == 'true'"
        >
          <label class="text-muted">
            <small>{{ SettingsStore.settings['FA1'] }}</small>
          </label>
          <br />
          {{ order.FA1 }}
        </div>
        <div
          class="col-2"
          v-show="SettingsStore.settings['FA2_Active'] == 'true' && SettingsStore.settings['FA2_Print'] == 'true'"
        >
          <label class="text-muted">
            <small>{{ SettingsStore.settings['FA2'] }}</small>
          </label>
          <br />
          {{ order.FA2 }}
        </div>
      </div>
      <hr />
      <!------------------ -->
      <div class="row mb-2">
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <label class="text-muted"><small>Auftragnehmer:</small></label>
            </div>
            <div class="col-6">
              {{ order.SupplierText }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <label class="text-muted"><small>Rechnungsnummer:</small></label>
            </div>
            <div class="col-6">
              {{ invoice.RNumber }}
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <label class="text-muted"><small>Auftragstatus / Datum:</small></label>
            </div>
            <div class="col-6">
              {{ computeOrderStatus(order) }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <label class="text-muted"><small>Belegart:</small></label>
            </div>
            <div class="col-6">
              {{ invoice.TypeText }}
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <label class="text-muted"><small>Freistellungsbescheinigung liegt vor:</small></label>
            </div>
            <div class="col-6">
              <b-form-checkbox
                style="margin-top: 0px"
                v-model="order.FreistellungCheck"
                :value="true"
                :unchecked-value="false"
                disabled
              >
                <small>{{ order.FreistellungCheck ? '&nbsp;(gültig bis ' + order.FreistellungDatum + ')' : '' }}</small>
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <!--
        <div class="col-2">
          <label class="text-muted" v-if="order.FreistellungDatum"><small>Gültig bis</small></label>
          <br />
          {{ order.FreistellungDatum }}
        </div>
        -->
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <label class="text-muted"><small>Rechnungsdatum</small></label>
            </div>
            <div class="col-6">
              {{ invoice.RDate }}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row mb-2">
        <div class="col-6">
          <label class="text-muted">
            <small>
              Gesamtauftragssumme (inkl. {{ order.AmountNachlass }} % Nachlass, per {{ $utils.currentGermanDate() }})
            </small>
          </label>
          <br />
          {{ $utils.numberToCurrency(parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered), true) }}
        </div>
        <div class="col-2">
          <label class="text-muted"><small>USt.-Satz</small></label>
          <br />
          {{ order.AmountMwSt != null ? order.AmountMwSt + ' %' : '(leer)' }}
        </div>
        <div class="col-2">
          <label class="text-muted"><small>Umsatzsteuer</small></label>
          <br />
          {{
            $utils.numberToCurrency(
              ((parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered)) * invoice.USt) / 100,
              true
            )
          }}
        </div>
        <div class="col-2">
          <label class="text-muted"><small>Bruttobetrag</small></label>
          <br />
          {{
            $utils.numberToCurrency(
              parseFloat(order.Amount) +
                parseFloat(order.AmountAddendumOrdered) +
                ((parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered)) * invoice.USt) / 100,
              true
            )
          }}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <label class="text-muted">
            <small>
              Zuvor abgerechnet
              <!-- {{ previousInvoices && previousInvoices.length > 0  ? '(pers ' + $utils.SQLDateToGermanDate(previousInvoices[0].CheckedDate) + ')' : '' }} -->
            </small>
          </label>
          <br />
          <!--- {{ $utils.formatCurrency(previousInvoice.LZWAccumulatedChecked, SettingsStore) }} --->
          <!-- {{ $utils.numberToCurrency(parseFloat(order.Invoiced), true) }} -->
          {{
            previousInvoices && previousInvoices.length > 0
              ? $utils.numberToCurrency(previousInvoices[previousInvoices.length - 1].LZWAccumulatedChecked, true)
              : ''
          }}
        </div>
        <div class="col-6">
          <label class="text-muted">
            <small>Obligo</small>
          </label>
          <br />
          {{ $utils.numberToCurrency(order.ObligoAmount, true) }}
        </div>
      </div>
      <hr />
      <div class="row mb-2">
        <div class="col-3">
          <label class="text-muted"><small>Rechnungssumme (ungeprüft)</small></label>
          <br />
          {{ $utils.numberToCurrency(invoice.Amount, true) }}
        </div>
        <div class="col-3">
          <label class="text-muted">
            <small>&nbsp;</small>
          </label>
          <br />
          {{ invoice.AmountCheckedType == 'Z' ? 'Zuwachs' : 'Kumuliert' }}
        </div>
        <div class="col-2">
          <label class="text-muted"><small>USt.-Satz</small></label>
          <br />
          {{ $utils.numberWithMaxFrictions(invoice.USt, 1) }} %
        </div>
        <div class="col-2">
          <label class="text-muted"><small>Umsatzsteuer</small></label>
          <br />
          {{ $utils.numberToCurrency((invoice.Amount * invoice.USt) / 100, true) }}
        </div>
        <div class="col-2">
          <label class="text-muted"><small>Bruttobetrag</small></label>
          <br />

          {{ $utils.numberToCurrency(parseFloat(invoice.Amount) + (invoice.Amount * invoice.USt) / 100, true) }}
        </div>
      </div>
      <hr />
      <div class="row mb-1">
        <div class="col-12">
          <h5 class="text-primary">Rechnungsprüfung</h5>
        </div>
      </div>
      <div class="row mt-1 mb-2" style="background-color: #eee; print-color-adjust: exact">
        <div class="col-6">
          <strong>Leistungsstand geprüft</strong>
          &nbsp;{{ invoice.CheckedDate ? '(am ' + invoice.CheckedDate + ')' : '' }}
        </div>
        <div class="col-2">
          <label class="text-muted"><small>USt.Satz</small></label>
        </div>
        <div class="col-2">
          <label class="text-muted"><small>Umsatzsteuer</small></label>
        </div>
        <div class="col-2">
          <label class="text-muted"><small>Bruttobetrag</small></label>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-4 pl-5">
          <label class="text-muted">Rechnungssumme (geprüft)</label>
        </div>
        <div class="col-2">{{ $utils.numberToCurrency(invoice.AmountChecked, true) }}</div>
        <div class="col-2">{{ $utils.numberWithMaxFrictions(invoice.UStChecked, 1) }} %</div>
        <div class="col-2">
          {{ $utils.numberToCurrency((invoice.AmountChecked * invoice.UStChecked) / 100, true) }}
        </div>
        <div class="col-2">
          {{
            $utils.numberToCurrency(invoice.AmountChecked + (invoice.AmountChecked * invoice.UStChecked) / 100, true)
          }}
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-4 pl-5">
          <label class="text-muted">Leistungszuwachs</label>
        </div>
        <div class="col-2">{{ $utils.numberToCurrency(invoice.LZWAmountChecked, true) }}</div>
        <div class="col-2">{{ $utils.numberWithMaxFrictions(invoice.UStChecked, 1) }} %</div>
        <div class="col-2">
          {{ $utils.numberToCurrency((invoice.LZWAmountChecked * invoice.UStChecked) / 100, true) }}
        </div>
        <div class="col-2">
          {{
            $utils.numberToCurrency(
              invoice.LZWAmountChecked + (invoice.LZWAmountChecked * invoice.UStChecked) / 100,
              true
            )
          }}
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-4 pl-5">
          <label class="text-muted">kumulierte Leistung</label>
        </div>
        <div class="col-2">{{ $utils.numberToCurrency(invoice.LZWAccumulatedChecked, true) }}</div>
        <div class="col-2">{{ $utils.numberWithMaxFrictions(invoice.UStChecked, 1) }} %</div>
        <div class="col-2">
          {{ $utils.numberToCurrency((invoice.LZWAccumulatedChecked * invoice.UStChecked) / 100, true) }}
        </div>
        <div class="col-2">
          {{
            $utils.numberToCurrency(
              invoice.LZWAccumulatedChecked + (invoice.LZWAccumulatedChecked * invoice.UStChecked) / 100,
              true
            )
          }}
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-6 pl-5 small">
          <strong>abzgl. Entgeltminderung mit Vorsteuerkürzung (EGMin mVK)</strong>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-4 pl-5">
          <div class="pl-5">
            <label class="text-muted text-break">{{ invoice.EGMComment }}</label>
          </div>
        </div>
        <div class="col-2" :style="{ color: !(invoice.EGMAmount && invoice.AmountChecked) ? '#ccc' : 'black' }">
          {{
            invoice.EGMAmount && invoice.AmountChecked
              ? $utils.numberWithMaxFrictions((invoice.EGMAmount / invoice.AmountChecked) * 100, 1) + '%'
              : '-'
          }}
        </div>
        <div class="col-2">{{ invoice.EGMAmount ? $utils.numberToCurrency(invoice.EGMAmount, true) : '- ' }}</div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-6 pl-5 small">
          <strong>abzgl. Sicherheitseinbehalt aus Vertragserfüllung (SEB VE)</strong>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-4 pl-5">
          <div class="pl-5">
            <b-form-checkbox
              style="margin-top: 0px"
              v-model="invoice.BuergschaftCheck"
              :value="true"
              :unchecked-value="false"
              disabled
            >
              Vertragsbürgschaft liegt vor
            </b-form-checkbox>
          </div>
        </div>
        <div class="col-2">
          {{
            invoice.BuergschaftCheck || !invoice.SEBPercent
              ? '-'
              : $utils.numberWithMaxFrictions(invoice.SEBPercent, 1) + '%'
          }}
        </div>
        <div class="col-2">
          {{ invoice.BuergschaftCheck || !invoice.SEBAmount ? '-' : $utils.numberToCurrency(invoice.SEBAmount, true) }}
        </div>
      </div>
      <hr />
      <div class="row mt-2 mb-2">
        <div style="-ms-flex: 0 0 24%;flex: 0 0 24%; max-width:24%;">&nbsp;</div>
        <div class="text-muted text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          <label class=""><small>Leistung</small></label>
        </div>
        <div class="text-muted text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          <label class=""><small>EGMin mVK</small></label>
        </div>
        <div class="text-muted text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          <label class=""><small>SEB VE</small></label>
        </div>
        <div class="text-muted text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          <label class=""><small>Netto&shy;betrag</small></label>
        </div>
        <div class="text-muted text-right px-0" style="-ms-flex: 0 0 7%;flex: 0 0 7%; max-width:7%;">
          <label class="">
            <small>
              USt.-
              <br />
              Satz
            </small>
          </label>
        </div>
        <div class="text-muted text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          <label class=""><small>Umsatz&shy;steuer</small></label>
        </div>
        <div class="text-muted text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          <label class=""><small>Brutto&shy;betrag</small></label>
        </div>
      </div>

      <div class="row mt-2 mb-2" style="background-color: #eee; print-color-adjust: exact">
        <div style="-ms-flex: 0 0 24%;flex: 0 0 24%; max-width:24%;padding-left: 15px">
          <strong>Gesamtanspruch kumuliert</strong>
        </div>
        <div
          class="text-right text-nowrap small px-0 my-auto"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          <!-- Leistung (Gesamtanspruch kumuliert) -->
          {{ $utils.numberToCurrency(invoice.LZWAccumulatedChecked, true) }}
        </div>
        <div
          class="text-right text-nowrap small px-0 my-auto"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          <!-- EGMin mVK (Gesamtanspruch kumuliert) -->
          {{ invoice.EGMAcc ? $utils.numberToCurrency(invoice.EGMAcc, true) : '- ' }}
        </div>
        <div
          class="col-1 text-right text-nowrap small px-0 my-auto"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          <!-- SEB VE (Gesamtanspruch kumuliert) -->
          {{ invoice.BuergschaftCheck || !invoice.SEBAmount ? '-' : $utils.numberToCurrency(invoice.SEBAmount, true) }}
        </div>
        <div
          class="text-right text-nowrap small px-0 my-auto"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          <!-- Nettobetrag (Gesamtanspruch kumuliert) -->
          {{
            $utils.numberToCurrency(
              invoice.LZWAccumulatedChecked -
                (invoice.EGMAcc ? invoice.EGMAcc : 0) -
                (!invoice.BuergschaftCheck && invoice.SEBAmount ? invoice.SEBAmount : 0),
              true
            )
          }}
        </div>
        <div class="text-right text-nowrap small px-0 my-auto" style="-ms-flex: 0 0 7%;flex: 0 0 7%; max-width:7%;">
          <!-- USt.-Satz (Gesamtanspruch kumuliert) -->
          {{ $utils.numberWithMaxFrictions(invoice.UStChecked, 1) }}%
        </div>
        <!-- Umsatzsteuer (Umsatzsteuer kumuliert) -->
        <div
          class="text-right text-nowrap small px-0 my-auto"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          {{
            $utils.numberToCurrency(
              ((invoice.LZWAccumulatedChecked -
                (invoice.EGMAcc ? invoice.EGMAcc : 0) -
                (!invoice.BuergschaftCheck && invoice.SEBAmount ? invoice.SEBAmount : 0)) *
                invoice.UStChecked) /
                100,
              true
            )
          }}
        </div>
        <!-- Bruttobetrag (Umsatzsteuer kumuliert) -->
        <div
          class="text-right text-nowrap small px-0 my-auto"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          {{
            $utils.numberToCurrency(
              invoice.LZWAccumulatedChecked -
                (invoice.EGMAcc ? invoice.EGMAcc : 0) -
                (!invoice.BuergschaftCheck && invoice.SEBAmount ? invoice.SEBAmount : 0) +
                ((invoice.LZWAccumulatedChecked -
                  (invoice.EGMAcc ? invoice.EGMAcc : 0) -
                  (!invoice.BuergschaftCheck && invoice.SEBAmount ? invoice.SEBAmount : 0)) *
                  invoice.UStChecked) /
                  100,
              true
            )
          }}
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-11 pl-5 small"><strong>abzgl. bisher freigegebene Rechnungen</strong></div>
      </div>
      <!-- bisherige Rechnungen -->
      <div class="row mt-2 mb-2" v-for="record in previousInvoices" :key="record.DbId">
        <div class="small" style="-ms-flex: 0 0 6%;flex: 0 0 6%; max-width:6%;">&nbsp;</div>
        <!-- Index (bisherige Rechnungen) -->
        <div class="small" style="-ms-flex: 0 0 6%;flex: 0 0 6%; max-width:6%;">ZF {{ record.Index }}</div>
        <!-- Rechnungsnummer (bisherige Rechnungen) -->
        <div class="small" style="-ms-flex: 0 0 8%;flex: 0 0 8%; max-width:8%;">{{ record.RNumber }}</div>
        <!-- Belegart kurz (bisherige Rechnungen) -->
        <div class="small" style="-ms-flex: 0 0 4%;flex: 0 0 4%; max-width:4%;">{{ record.TypeTextShort }}</div>
        <!-- Leistung (bisherige Rechnungen) -->
        <div class="small text-right text-nowrap px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ $utils.numberToCurrency(record.LZWAmountChecked, true) }}
        </div>
        <!-- EGMin VK (bisherige Rechnungen) -->
        <div class="small text-nowrap text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ record.EGMZWAmount ? $utils.numberToCurrency(record.EGMZWAmount, true) : '- ' }}
        </div>
        <!-- SEB VE (bisherige Rechnungen) -->
        <div class="small text-nowrap text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ record.BuergschaftCheck || !record.SEBZWAmount ? '-' : $utils.numberToCurrency(record.SEBZWAmount, true) }}
        </div>
        <!-- Nettobetrag (bisherige Rechnungen) -->
        <div class="small text-nowrap text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ $utils.numberToCurrency(record.LZWAmountChecked - record.EGMZWAmount - record.SEBZWAmount, true) }}
        </div>
        <!-- USt.-Satz (bisherige Rechnungen) -->
        <div class="small text-nowrap text-right px-0" style="-ms-flex: 0 0 7%;flex: 0 0 7%; max-width:7%;">
          <!-- <div class="col-1 very-small text-nowrap text-right px-0"> -->
          {{ $utils.numberWithMaxFrictions(record.UStChecked, 1) }}%
        </div>
        <div class=" small text-nowrap text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{
            $utils.numberToCurrency(
              ((record.LZWAmountChecked - record.EGMZWAmount - record.SEBZWAmount) * record.UStChecked) / 100,
              true
            )
          }}
        </div>
        <div class="small text-nowrap text-right px-0" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{
            $utils.numberToCurrency(
              record.LZWAmountChecked -
                record.EGMZWAmount -
                record.SEBZWAmount +
                ((record.LZWAmountChecked - record.EGMZWAmount - record.SEBZWAmount) * record.UStChecked) / 100,
              true
            )
          }}
        </div>
      </div>
      <!-- /row -->
      <!-- S U M M E N (bisherige Rechnungen) -->
      <div class="row mt-2 mb-2">
        <div class="" style="-ms-flex: 0 0 19%;flex: 0 0 19%; max-width:19%;">&nbsp;</div>
        <div class="border-top small" style="-ms-flex: 0 0 5%;flex: 0 0 5%; max-width:5%;">Summe:</div>
        <!-- Leistung (S U M M E N bisherige Rechnungen) -->
        <div
          class="border-top text-right small text-nowrap px-0"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          {{ $utils.numberToCurrency(previousSumLZWAmountChecked, 1) }}
        </div>
        <!-- EGMin mVK (S U M M E N bisherige Rechnungen) -->
        <div
          class="border-top text-right small text-nowrap px-0"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          {{ $utils.numberToCurrency(previousSumEGMAmount, 1) }}
        </div>
        <!-- SEB VE (S U M M E N bisherige Rechnungen) -->
        <div
          class="border-top text-right small text-nowrap px-0"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          {{ $utils.numberToCurrency(previousSumSEBAmount, 1) }}
        </div>
        <!-- Nettobetrag (S U M M E N bisherige Rechnungen) -->
        <div
          class="border-top text-right small text-nowrap px-0"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          {{ $utils.numberToCurrency(previousSumLZWAmountChecked - previousSumEGMAmount - previousSumSEBAmount, 1) }}
        </div>
        <!-- USt.-Satz wird nicht summiert (S U M M E N bisherige Rechnungen) -->
        <div
          class="border-top text-right very-small text-nowrap px-0"
          style="-ms-flex: 0 0 7%;flex: 0 0 7%; max-width:7%;"
        >
          &nbsp;
        </div>
        <!-- Umsatzsteuer (S U M M E N bisherige Rechnungen) -->
        <div
          class="border-top text-right small text-nowrap px-0"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          {{ $utils.numberToCurrency(previousSumUStAmount, 1) }}
        </div>
        <!-- Bruttobetrag (S U M M E N bisherige Rechnungen) -->
        <div
          class="border-top text-right small text-nowrap px-0"
          style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;"
        >
          {{ $utils.numberToCurrency(previousSumBrutto, 1) }}
        </div>
      </div>
      <!-- Z A H L U N G S A N S P R U C H -->
      <div class="row mt-3 " style="background-color: #eee; print-color-adjust: exact">
        <div class="col"><strong>Zahlungsanspruch</strong></div>
      </div>
      <div class="row mb-2" style="background-color: #eee; print-color-adjust: exact">
        <div style="-ms-flex: 0 0 6%;flex: 0 0 6%; max-width:6%;">&nbsp;</div>
        <div class="small" style="-ms-flex: 0 0 6%;flex: 0 0 6%; max-width:6%;">ZF {{ invoice.Index }}</div>
        <div class="small" style="-ms-flex: 0 0 12%;flex: 0 0 12%; max-width:12%;">{{ invoice.RNumber }}</div>
        <!-- <div class="small" style="-ms-flex: 0 0 4%;flex: 0 0 4%; max-width:4%;"></div> -->
        <!-- L E I S T U N G (Zahlungsanspruch) -->
        <div class="text-right px-0 small text-nowrap" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ $utils.numberToCurrency(invoice.LZWAccumulatedChecked - previousSumLZWAmountChecked, true) }}
        </div>
        <!-- EGMin mVK (Zahlungsanspruch) -->
        <div class="text-right px-0 small text-nowrap" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ $utils.numberToCurrency(invoice.EGMZWAmount, true) }}
        </div>
        <!-- SEB VE (Zahlungsanspruch) -->
        <div class="text-right px-0 small text-nowrap" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ $utils.numberToCurrency(invoice.SEBAmount - previousSumSEBAmount, true) }}
        </div>
        <!-- Nettobetrag mVK (Zahlungsanspruch) -->
        <div class="text-right px-0 small text-nowrap" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{
            $utils.numberToCurrency(
              invoice.LZWAccumulatedChecked -
                previousSumLZWAmountChecked -
                invoice.EGMZWAmount -
                (invoice.SEBAmount - previousSumSEBAmount),
              true
            )
          }}
        </div>
        <!-- USt.-Satz (Zahlungsanspruch) -->
        <div class="text-right px-0 small text-nowrap" style="-ms-flex: 0 0 7%;flex: 0 0 7%; max-width:7%;">
          {{ $utils.numberWithMaxFrictions(invoice.UStChecked, 1) }}%
        </div>
        <!-- Umsatzsteuer (Zahlungsanspruch) -->
        <div class="text-right px-0 small text-nowrap" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ $utils.numberToCurrency(invoice.ZAUStAmount, true) }}
        </div>
        <!-- Bruttobetrag (Zahlungsanspruch) -->
        <div class="text-right px-0 small text-nowrap" style="-ms-flex: 0 0 11.5%;flex: 0 0 11.5%; max-width:11.5%;">
          {{ $utils.numberToCurrency(invoice.ZABrutto, true) }}
          <!--
          {{
            $utils.numberToCurrency(
              (invoice.LZWAccumulatedChecked -
                previousSumLZWAmountChecked -
                invoice.EGMZWAmount -
                (invoice.SEBAmount - previousSumSEBAmount) +
                ((invoice.LZWAccumulatedChecked -
                  previousSumLZWAmountChecked -
                  invoice.EGMZWAmount -
                  (invoice.SEBAmount - previousSumSEBAmount)) *
                  invoice.UStChecked) /
                  100),
              true
            )
          }}
          -->
        </div>
      </div>
      <div class="row mt-3 mb-2" v-if="invoice.UStAusgleich && invoice.UStAusgleich > 0">
        <div class="col-10 text-right">Ausgleich Umsatzsteuer:</div>
        <div class="col-1 text-right small px-0">
          {{ $utils.numberToCurrency(invoice.UStAusgleich, true) }}
        </div>
        <div class="col-1 text-right"></div>
      </div>
      <div class="row mb-2" v-show="invoice.Type != 3 && invoice.UStAusgleich && invoice.UStAusgleich > 0">
        <div class="col-11 text-right font-italic text-muted">
          Der Ausgleich der Umsatzsteuer erfolgt mit der Schlussrechnung zum Zeitpunkt des dann maßgeblichen
          Umsatzsteuersatzes.
        </div>
      </div>
      <div class="row mt-3 mb-2" v-show="invoice.Type == 3 && invoice.UStAusgleich && invoice.UStAusgleich > 0">
        <div class="col-10 text-right">Zahlungsanspruch mit Ausgleich der Umsatzsteuer:</div>
        <!-- Ausgleich Umsatzsteuer (Zahlungsanspruch nach Ausgleich der Umsatzsteuer) -->
        <div class="col-1 px-0 text-right small">
          {{ $utils.numberToCurrency(invoice.ZAUStAmountIncl, true) }}
        </div>
        <!-- Zahlungsanspruch nach Ausgleich der Umsatzsteuer (Zahlungsanspruch nach Ausgleich der Umsatzsteuer) -->
        <div class="col-1 px-0 text-right small">
          <!--
          {{ $utils.numberToCurrency(
              ((invoice.LZWAccumulatedChecked - previousSumLZWAmountChecked) - invoice.EGMZWAmount - (invoice.SEBAmount - previousSumSEBAmount)) + 
              (((invoice.LZWAccumulatedChecked - previousSumLZWAmountChecked) - invoice.EGMZWAmount - (invoice.SEBAmount - previousSumSEBAmount)) * 19 / 100) + 
              (invoice.GAUStAmount  - previousSumGAUStAmount) - ((invoice.LZWAccumulatedChecked - previousSumLZWAmountChecked) - invoice.EGMZWAmount - (invoice.SEBAmount - previousSumSEBAmount)) * 19 / 100
            , true) 
          }}
                -->
          {{ $utils.numberToCurrency(invoice.ZABruttoIncl, true) }}
        </div>
      </div>
      <hr class="ml-5" />
      <div class="row mt-2 mb-2">
        <div class="col-11 pl-5 small"><strong>abzgl. Entgeltminderung ohne Vorsteuerkürzung</strong></div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-2 small">&nbsp;</div>
        <div class="col-8 small text-right text-muted">bisher vorgenommene Abzüge</div>
        <div class="col-1 small text-right text-muted px-0">
          {{ $utils.numberToCurrency(previousSumEGMOAmount, true) }}
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-1">&nbsp;</div>
        <div class="col-9 border text-right">{{ invoice.EGMOComment }}</div>
        <div class="col-1 text-right"></div>
        <div class="col-1 border text-right px-0">{{ $utils.numberToCurrency(invoice.EGMOAmount, true) }}</div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-2">&nbsp;</div>
        <div class="col-8 small text-right text-muted">Gesamtsumme Abzüge</div>
        <div class="col-1 small text-right text-muted px-0">
          {{ $utils.numberToCurrency(invoice.EGMOAmount + previousSumEGMOAmount, true) }}
        </div>
      </div>
      <!-- Sicherheitseinbehalt für Mängelhaftung Vertragserfüllung -->
      <!-- show only, if belegArt == schlussrechnung (3) -->
      <div class="row mt-2 mb-2" v-show="invoice.Type == 3">
        <div class="col-11 pl-5"><strong>abzgl. Sicherheitseinbehalt für Mängelhaftung Vertragserfüllung</strong></div>
      </div>
      <div class="row mt-2 mb-2" v-show="invoice.Type == 3">
        <div class="col-1">&nbsp;</div>
        <div class="col-4 px-0">
          <label class="text-muted"><small>Mängelhaftungsbürgschaft liegt vor</small></label>
          <br />
          {{ invoice.SFMCheck ? 'Ja' : 'Nein' }}
        </div>
        <div class="col-4 px-0">
          <label class="text-muted"><small>Einbehalt wird berechnet aus</small></label>
          <br />
          {{ MSicherVons[order.MSicherVon] }}
        </div>
        <div class="col-1 text-right px-0 small">
          <!-- Betrag basierend auf Netto/Brutto-Abrechnungssumme -->
          {{ $utils.numberToCurrency(invoice.SFMBasisAmount, true) }}
        </div>
        <div class="col-1 p-0 small">
          <div class="text-right border" style="padding-right: 15px">
            {{ $utils.numberWithMaxFrictions(invoice.SFMPercent, 1) }}%
          </div>
        </div>
        <div class="col-1 text-right px-0 small">
          <!-- Umsatzsteuer basierend auf Netto/Brutto-Abrechnungssumme -->
          {{ $utils.numberToCurrency(invoice.SFMMHAmount, true) }}
        </div>
      </div>
      <div class="row mt-3 mb-2" style="background-color: #eee; print-color-adjust: exact">
        <div class="col-10"><strong>Auszahlungsbetrag</strong></div>
        <!-- A U S Z A H L U N G S B E T R A G -->
        <div class="col-2 text-right text-nowrap px-0">
          <strong>{{ $utils.numberToCurrency(invoice.AZAmount, true) }}</strong>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-1">&nbsp;</div>
        <div class="col-5 px-0">
          <label class="text-muted"><small>Skontoabzug vereinbart</small></label>
          <br />
          {{ invoice.SkontoCheck ? 'Ja' : 'Nein' }}
        </div>
        <div class="col-3 px-0" v-if="invoice.SkontoCheck">
          <label class="text-muted"><small>Skontofrist</small></label>
          <br />
          {{ invoice.SkontoFrist }}
        </div>
        <div class="col-2 px-0" v-if="invoice.SkontoCheck">
          <label class="text-muted"><small>Skonto</small></label>
          <br />
          {{ $utils.numberWithMaxFrictions(invoice.SkontoProzent, 1) }}%
        </div>
        <div class="col-1 px-0 text-right" v-if="invoice.SkontoCheck">
          <label class="text-muted"><small></small></label>
          <br />
          {{ $utils.numberToCurrency(this.invoice.SkontoAmount, true) }}
        </div>
      </div>
      <div class="row mt-2 mb-2" v-if="invoice.SkontoCheck">
        <div class="col-2">&nbsp;</div>
        <div class="col-9 text-right">Auszahlungsbetrag nach Skontoabzug:</div>
        <div class="col-1 text-right px-0">
          <!-- A U S Z A H L U N G S B E T R A G   N A C H   S K O N T O A N Z U G -->
          {{ $utils.numberToCurrency(this.invoice.AZAmount - this.invoice.SkontoAmount, true) }}
        </div>
      </div>
      <div class="row mt-4 mb-2">
        <div class="col-8 border border-primary very-small">
          Haftungsausschluss: Das Formular ist lediglich eine Darstellungsart der vom Auftraggeber zur Verfügung
          gestellten und vom Benutzer eigenverantwortlich erfassten Daten. BauVisor oder der Anwender des Formulares
          übernehmen keine Haftung für etwaige Fehler oder daraus resultierende fehlerhafte Zahlungsanweisungen. Der
          Auftraggeber ist verpflichtet alle Angaben auf die für ihn geltenden gesetzlichen oder steuerrechtlichen
          Regelungen hin zu überprüfen. Insbesondere kann im Rahmen der kumulierten Rechnungsstellung keine Gewähr für
          tatsächlich erfolgte Zahlungsstände übernommen werden. Der Auftraggeber ist verpflichtet den Auszahlungsbetrag
          anhand seiner bisher vorgenommenen Zahlungsanweisungen zu überprüfen.
        </div>
        <div class="col-4 mt-auto"><div class="ml-2 border-top">Datum, Unterschrift</div></div>
      </div>
      <!--
      <div class="row mt-2 mb-2">
        <div class="col-2">&nbsp;</div>
        <div class="col-3 pl-0 ">
          <b-form-checkbox
            style="margin-top: 0px"
            v-model="order.FreistellungCheck"
            :value="true"
            :unchecked-value="false"
            disabled>
            Mängelhaftungsbürgschaft liegt vor
          </b-form-checkbox>
        </div>
        <div class="col-3">Einbehalt wird berechnet aus</div>
        <div class="col-2 border">Brutto-Abrechnungssumme</div>
      </div>-->
    </div>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import InvoicesService from '@/service/InvoicesService.js';
import OrdersService from '@/service/OrdersService.js';
import SettingsStore from '@/store/Settings';
import ProjectsStore from '@/store/Projects';

export default {
  activated() {
    const task1 = this.loadOrder();
    const task2 = this.loadInvoice();
    const task3 = this.loadPrevious();
    Promise.all([task1, task2, task3]).then(() => {
      this.calcComputedFields();
    });
  },
  data() {
    return {
      ProjectsStore,
      SettingsStore,
      AppState,
      order: {},
      invoice: {},
      projectIdentifier: null,
      previousInvoices: [],
      previousSumLZWAmountChecked: 0,
      previousSumEGMAmount: 0,
      previousSumSEBAmount: 0,
      previousSumGAAmount: 0,
      previousSumUStAmount: 0,
      previousSumBrutto: 0,
      previousSumEGMOAmount: 0,
      MSicherVons: ['Netto-Abrechnungssumme', 'Brutto-Abrechnungssumme']
    };
  },
  methods: {
    async loadOrder() {
      return OrdersService.getById(this.$route.params.id)
        .then(order => {
          this.projectIdentifier =
            ProjectsStore.projects.find(x => x.DbId == order.ProjectId).ProjectIdentifier +
            ' ' +
            ProjectsStore.projects.find(x => x.DbId == order.ProjectId).Name;
          this.order = order;
          this.order.FreistellungDatum = this.$utils.SQLDateToGermanDate(this.order.FreistellungDatum);
          this.order.FreistellungCheck =
            this.order.FreistellungCheck && this.order.FreistellungCheck == 'true' ? true : false;
          if (!this.order.NTR) {
            this.order.NTR = parseFloat(SettingsStore.settings['Nachtragsprozent']).toFixed(2);
          }
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(async () => {
          await this.$forceUpdate();
          AppState.isLoading = false;
        });
    },
    async loadInvoice() {
      return InvoicesService.getById(this.$route.params.iid).then(invoice => {
        this.invoice = invoice;
        this.invoice.RDate = this.$utils.SQLDateToGermanDate(this.invoice.RDate);
        this.invoice.CreatedDate = this.$utils.SQLDateToGermanDate(this.invoice.CreatedDate);
        this.invoice.CheckedDate = this.$utils.SQLDateToGermanDate(this.invoice.CheckedDate);
        invoice.EGMProzent =
          invoice.EGMAmount && invoice.AmountChecked
            ? parseFloat(((invoice.EGMAmount / invoice.AmountChecked) * 100).toFixed(1))
            : null;
        //if (!this.invoice.USt) this.invoice.USt = SettingsStore.settings['Mehrwertsteuersatz'];
        //if (!this.invoice.UStChecked) this.invoice.UStChecked = SettingsStore.settings['Mehrwertsteuersatz'];
      });
    },
    async loadPrevious() {
      return InvoicesService.getAllPreviousById(this.$route.params.id, this.$route.params.iid).then(invoices => {
        invoices.map(x => {
          x.TypeTextShort = this.AppState.invoiceTypes.find(y => y.DbId == x.Type).Abbreviation;
          this.previousSumLZWAmountChecked += x.LZWAmountChecked ? x.LZWAmountChecked : 0;
          this.previousSumEGMAmount += x.EGMZWAmount ? x.EGMZWAmount : 0;
          this.previousSumSEBAmount += x.SEBZWAmount ? x.SEBZWAmount : 0;
          this.previousSumGAAmount += x.GAAmount ? x.GAAmount : 0;
          this.previousSumUStAmount += ((x.LZWAmountChecked - x.EGMZWAmount - x.SEBZWAmount) * x.UStChecked) / 100;
          this.previousSumBrutto +=
            x.LZWAmountChecked -
            x.EGMZWAmount -
            x.SEBZWAmount +
            ((x.LZWAmountChecked - x.EGMZWAmount - x.SEBZWAmount) * x.UStChecked) / 100;
          this.previousSumEGMOAmount += x.EGMOAmount ? x.EGMOAmount : 0;
          return x;
        });
        this.previousInvoices = invoices;
      });
    },
    printIt() {
      window.print();
    },
    closeIt() {
      window.close();
    },
    computeOrderStatus(item) {
      if (item.veSection && item.veSection == 'A') {
        return (
          (item.VergabeEmpfehlung && item.VergabeEmpfehlung != '' ? item.VergabeEmpfehlung : 'Empfehlung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.VergabeEmpfehlungDatum)
        );
      } else if (item.veSection && item.veSection == 'B') {
        return (
          (item.OrderNumber && item.OrderNumber != '' ? item.OrderNumber : 'Bestellung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.OrderDate)
        );
      } else return '';
    },
    calcComputedFields() {
      var previousInvoice = this.previousInvoices[this.previousInvoices.length - 1];
      if (!previousInvoice) previousInvoice = {};
      if (!previousInvoice.LZWAmount) previousInvoice.LZWAmount = 0;
      if (!previousInvoice.LZWAccumulatedChecked) previousInvoice.LZWAccumulatedChecked = 0;
      if (!previousInvoice.LZWAmountChecked) previousInvoice.LZWAmountChecked = 0;
      if (!previousInvoice.EGMZWAmount) previousInvoice.EGMZWAmount = 0;
      if (!previousInvoice.EGMAcc) previousInvoice.EGMAcc = 0;
      if (!previousInvoice.SEBZWAmount) previousInvoice.SEBZWAmount = 0;
      if (!previousInvoice.SEBAcc) previousInvoice.SEBAcc = 0;
      if (!previousInvoice.ZAUStAmountSum) previousInvoice.ZAUStAmountSum = 0;
      if (!previousInvoice.SFMPreviousAmount) previousInvoice.SFMPreviousAmount = 0;
      if (!this.invoice.SFMPreviousAmount) this.invoice.SFMPreviousAmount = 0;
      if (this.invoice.AmountCheckedType == 'Z') {
        /* **********************

                  Z

        ************************ */
        /*
        this.invoice.LZWAccumulatedChecked = this.invoice.AmountChecked
          ? previousInvoice.LZWAccumulatedChecked + parseFloat(this.invoice.AmountChecked)
          : previousInvoice.LZWAccumulatedChecked;
          */
        this.invoice.LZWAmountChecked = this.invoice.AmountChecked ? parseFloat(this.invoice.AmountChecked) : 0;
        this.invoice.LZWAmount = this.invoice.Amount ? parseFloat(this.invoice.Amount) : 0;
        this.invoice.EGMZWAmount = this.invoice.EGMAmount ? parseFloat(this.invoice.EGMAmount) : 0;
        this.invoice.EGMAcc =
          this.invoice.EGMAmount && parseFloat(this.invoice.EGMAmount) > 0
            ? previousInvoice.EGMAcc + parseFloat(this.invoice.EGMAmount)
            : previousInvoice.EGMAcc;
        this.invoice.SEBZWAmount = this.invoice.SEBAmount ? parseFloat(this.invoice.SEBAmount) : 0;
        this.invoice.SEBAcc = this.invoice.SEBAmount
          ? previousInvoice.SEBAcc + this.invoice.SEBAmount
          : previousInvoice.SEBAcc;
      } else if (this.invoice.AmountCheckedType == 'K') {
        /* **********************

                  K

        ************************ */
        this.invoice.LZWAmount = this.invoice.Amount
          ? parseFloat(this.invoice.Amount) - previousInvoice.LZWAccumulated
          : 0;
        /*
        this.invoice.LZWAccumulatedChecked = previousInvoice.AmountChecked
          ? parseFloat(this.invoice.AmountChecked)
          : parseFloat(this.invoice.LZWAccumulatedChecked);
          */
        /* vor Änderung am 01.03.2023:
                  this.invoice.LZWAccumulatedChecked = this.previousInvoice.LZWAccumulatedChecked
          ? parseFloat(this.invoice.AmountChecked)
          : parseFloat(this.invoice.AmountChecked);
          */
        this.invoice.LZWAmountChecked = this.invoice.AmountChecked
          ? parseFloat(this.invoice.AmountChecked) - previousInvoice.LZWAccumulatedChecked
          : 0;
        this.invoice.EGMZWAmount = this.invoice.EGMAmount
          ? parseFloat(this.invoice.EGMAmount) - parseFloat(previousInvoice.EGMAcc)
          : 0 - parseFloat(previousInvoice.EGMAcc);
        this.invoice.EGMAcc = previousInvoice.EGMAcc + this.invoice.EGMZWAmount;
        this.invoice.SEBZWAmount = this.invoice.SEBAmount
          ? parseFloat(this.invoice.SEBAmount) - parseFloat(previousInvoice.SEBAcc)
          : 0;
        this.invoice.SEBAcc = this.invoice.SEBAmount ? parseFloat(this.invoice.SEBAmount) : previousInvoice.SEBAcc;
      }

      this.invoice.GAAmount = this.invoice.LZWAccumulatedChecked - this.invoice.EGMAcc - this.invoice.SEBAcc;
      this.invoice.GAUStAmount = this.$utils.round((this.invoice.GAAmount * this.invoice.UStChecked) / 100);

      this.invoice.GABrutto = this.invoice.GAAmount + this.invoice.GAUStAmount;

      // ZAAmount           Zahl.anspruch netto
      this.invoice.ZAAmount = this.invoice.LZWAmountChecked - this.invoice.EGMZWAmount - this.invoice.SEBZWAmount;

      // ZAUStAmount        ZA USt.-Wert
      /*
      this.invoice.ZAUStAmount = this.invoice.UStChecked
        ? this.$utils.round((this.invoice.ZAAmount * this.invoice.UStChecked) / 100)
        : 0;
*/
      // ZABrutto          (Zahl.anspruch\nbrutto o UStA.)
      //this.invoice.ZABrutto = this.invoice.ZAAmount + this.invoice.ZAUStAmount;

      // ZAUStAmountSum     (Summe\n32_ZA_UStWert)

      // ZAUStAmountIncl   (ZA_UStWert\nInklAusgleich)

      //this.invoice.ZAUStAmountIncl = this.invoice.GAUStAmount - this.invoice.ZAUStAmountSum;

      // UStAusgleich      USt-\nAusgleich
      //this.invoice.UStAusgleich = this.invoice.ZAUStAmountIncl - this.invoice.ZAUStAmount;

      // ZABruttoIncl
      //this.invoice.ZABruttoIncl = this.invoice.ZABrutto + this.invoice.UStAusgleich;

      // ZABruttoMaßgeblich     Zahl.Anspruch\nbrutto
      //this.invoice.ZABruttoMaßgeblich = this.invoice.Type == 3 ? this.invoice.ZABruttoIncl : this.invoice.ZABrutto;

      // SFMBasisAmount     SEB MH Basiswert
      if (this.order.MSicherVon == 0) {
        this.invoice.SFMBasisAmount = this.invoice.LZWAccumulatedChecked;
      } else if (this.order.MSicherVon == 1) {
        this.invoice.SFMBasisAmount =
          this.invoice.LZWAccumulatedChecked +
          this.$utils.round((this.invoice.LZWAccumulatedChecked * this.invoice.UStChecked) / 100);
      }

      // SFMMHAmount        SEB MH
      this.invoice.SFMMHAmount = this.invoice.SFMPercent
        ? this.$utils.round((this.invoice.SFMPercent * this.invoice.SFMBasisAmount) / 100)
        : 0;
      // SFMMHDeltaAmount   SEB MH Veränderung
      this.invoice.SFMMHDeltaAmount = this.invoice.SFMMHAmount - this.invoice.SFMPreviousAmount;

      // AZAmount           Auszahlung brutto
      // thilo hat es geändert von nach ausgleich uststeuer auf zahlunganspruch brutto
      //this.invoice.AZAmount = this.invoice.ZABruttoMaßgeblich - this.invoice.EGMOAmount - this.invoice.SFMMHDeltaAmount;
      /*
      this.invoice.AZAmount =
        (this.invoice.Type == 3 ? this.invoice.ZABruttoMaßgeblich : this.invoice.ZABrutto) -
        this.invoice.EGMOAmount -
        (this.invoice.Type == 3 ? this.invoice.SFMMHDeltaAmount : 0);

      this.invoice.SkontoAmount = this.invoice.SkontoProzent
        ? this.$utils.round((this.invoice.AZAmount * parseFloat(this.invoice.SkontoProzent)) / 100)
        : 0;
*/
      this.$forceUpdate();
    }
  }
};
</script>

<style>
body,
html,
#app,
#main-panel,
#page-wrapper {
  overflow: visible !important;
}
@page {
  size: A4;
  width: 210mm;
  height: 297mm;
}

hr {
  margin-top: 0;
  margin-bottom: 0.2rem;
}
label {
  margin-bottom: 0.2rem;
}
#print-container {
  max-width: 1050px;
  overflow: visible;
}
#print-container-wrapper {
  height: 100%;
  overflow: visible;
}
@media print {
  html,
  body {
    height: 100%;
    width: 210mm;
    height: 297mm;
  }
  #print-container {
    max-width: 1050px;
    overflow: visible;
  }
  #print-container-wrapper {
    overflow: visible;
  }
}
.very-small {
  font-size: 0.71em;
  font-weight: 400;
}
</style>
